import React, {Component} from "react";
import {Button} from "../components/atoms/buttons/Button";

class Post extends Component {
    render() {
        return (
            <div className='w-full h-[100vh] flex flex-col items-center justify-center bg-brand'>
                <div className='burst'/>
                <div className='burst2'/>
                <div className='mb-5'>
                    <img className='w-40' src={require('../img/brand/full_logo.png')}/>
                </div>
                <div className='flex flex-col bg-white z-[2] shadow-2xl p-8 rounded-2xl mb-5 w-[500px]'>
                    <p className={'heading3 text-gray-800 mb-4'}>
                        Create a Post
                    </p>
                    <p className='body1 text-gray-500 mb-6'>
                        To create a post for your nonprofit, please visit starfishapp.com and sign in with the same credentials you used to access this admin dashboard.
                    </p>
                    <p className='body1 text-gray-500 mb-6'>
                        Once you're signed in, look for the "Post" button in the top right corner of the screen and click it to switch to posting on behalf of your nonprofit.
                    </p>
                    <div className='w-full flex-1 flex-col flex items-stretch justify-stretch'>
                        <a 
                            href="https://starfishapp.com" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className='w-full flex-1 flex flex-col'
                        >
                            <Button variant={'default'} className='mt-4 w-full'>
                                Go to Starfish App
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Post;
